import { faArrowTurnDownRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import { modNameChanger } from '../../../utils/utilities'

const ReplyTo = ({ user, message }) => {
  const processTagging = (name) =>
    user && user.userService.profile.name === name
      ? 'bg-blue-200 dark:bg-blue-900 text-neutral-800 dark:text-neutral-200 rounded-full py-0.5'
      : 'text-neutral-600 dark:text-neutral-400 py-0'

  return (
    <div
      className={`px-1 mx-2 mb-1.5 font-medium text-xs truncate max-w-96 ${processTagging(
        message.user.userService.profile.name
      )}`}
      title={`Replying to ${modNameChanger(message)}: ${message.message}`}
    >
      <FontAwesomeIcon
        className="mr-1 h-2 rotate-90"
        icon={faArrowTurnDownRight}
      />
      {`Replying to ${modNameChanger(message)}: ${message.message}`}
    </div>
  )
}

ReplyTo.propTypes = {
  user: PropTypes.object,
  message: PropTypes.object.isRequired
}

export default ReplyTo
